import { KatalComponent, register } from '../../shared/base';

@register('kat-table-row')
export class KatTableRow extends KatalComponent {
  static get observedAttributes() {
    return [];
  }

  constructor() {
    super(KatTableRow.observedAttributes);
  }

  connectedCallback() {
    super.connectedCallback();

    this.setAttribute('role', 'row');
  }
}
